import { option, pipe } from '@code-expert/prelude';
import type { SetPageParams } from '/imports/ui/navigation/pageParams';
import { PageParams, updatePageParams } from '/imports/ui/navigation/pageParams';
import { UiState } from '/imports/utils/UiState';

export const pageParamsUiState = UiState.valueProp('pageParams', PageParams);

export const setPageParamsUiState = (params: SetPageParams) => {
  pageParamsUiState.modify(updatePageParams(params));
};

export const clearPageParamsUiState = () => {
  pageParamsUiState.clear();
};

export const getPageParamsUiState = <K extends keyof PageParams>(
  key: K,
): option.Option<Required<PageParams>[K]> =>
  pipe(
    option.fromNullable(pageParamsUiState.get()),
    option.chainNullableK((s) => s[key]),
  );
